"use strict";

var _taggedTemplateLiteral = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", " {\n    .ant-tree-indent-unit {\n      width: 8px;\n    }\n  }\n  .ant-tree-treenode {\n    padding: 0 0 ", " 0;\n  }\n  .ant-tree-switcher {\n    transition: color 0.1s linear, transform 0.25s cubic-bezier(0.16, 1, 0.3, 1);\n    transform: rotate(0deg);\n    &.ant-tree-switcher_open {\n      transform: rotate(90deg);\n    }\n    &.ant-tree-switcher-noop {\n      width: 8px;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tree = void 0;

var antd_1 = require("antd");

var iconoir_react_1 = require("iconoir-react");

var react_1 = __importDefault(require("react"));

var styledTypes_1 = require("./styledTypes");

function Tree(_a) {
  var compact = _a.compact,
      rest = __rest(_a, ["compact"]);

  return react_1["default"].createElement(Container, {
    compact: compact
  }, react_1["default"].createElement(antd_1.Tree, Object.assign({
    switcherIcon: react_1["default"].createElement(iconoir_react_1.NavArrowRight, null)
  }, rest)));
}

exports.Tree = Tree;
var Container = styledTypes_1.styled.div(_templateObject(), function (props) {
  return props.compact ? '&' : '&.noop';
}, function (props) {
  return props.theme['@size-xs'];
});